export function renderLoadmoreItem(data,type){
    //0 - спектакли
    //1 - новости
    //2 - проекты (поэтомания)
    //3 - мы в сми

    let result = '';

    switch (type) {
        case 0:
            data.result.forEach(perfItem => {
                result += `
          <a href="${perfItem.url}" class="item">
          <div class="img">
            <img class="plan-img lozad" data-background="${perfItem.image}">
          </div>
          <div class="flat-info">
          <div class="flat-number">${perfItem.flat_number}</div>
            <div class="sub-info">
              <div class="area">
                <p class="desc">Площадь</p>
                ${perfItem.area} м<sup>2</sup>
              </div>
              <div class="flat-section">
                <p class="desc">Секция</p>
                ${perfItem.section}
              </div>
          </div>
          </div>
        </a>`;
            });
            break;

        case 1:
            data.result.forEach(perfItem => {
                result += `
                        `;
            });
            break;

        case 2:
            data.result.forEach(perfItem => {
                result += `
                        <a href="${perfItem.url}" class="item">
          <div class="img">
            <img class="plan-img lozad" data-background="${perfItem.image}">
          </div>
          <div class="flat-info">
          <div class="flat-number">${perfItem.flat_number}</div>
            <div class="sub-info">
              <div class="area">
                <p class="desc">Площадь</p>
                ${perfItem.area} м<sup>2</sup>
              </div>
              <div class="flat-section">
                <p class="desc">Секция</p>
                ${perfItem.section}
              </div>
          </div>
          </div>
        </a>`;
            });
            break;
    }

    return result;
}